import type { EntityState } from '../../lib/api.js';
import { useDevices } from '../../context/DevicesContext.js';
import { Button } from '../ui/Button.js';
import { friendlyName } from '../../lib/utils.js';
import { useToast } from '../ui/Toast.js';

interface Props {
  entityId: string;
  entity: EntityState;
}

export function CoverCard({ entityId, entity }: Props) {
  const { sendCommand } = useDevices();
  const toast = useToast();

  const send = async (service: string) => {
    try {
      await sendCommand('cover', service, entityId);
    } catch {
      toast.show('Command failed', 'error');
    }
  };

  return (
    <div
      className="p-4 rounded-xl border flex flex-col gap-2"
      style={{ backgroundColor: 'var(--ac-surface)', borderColor: 'var(--ac-border)' }}
    >
      <div className="flex justify-between">
        <div className="font-medium text-[var(--ac-text)]">
          {friendlyName(entityId, entity.attributes)}
        </div>
        <div className="text-xs text-[var(--ac-text-muted)]">{entity.state}</div>
      </div>
      <div className="flex gap-2">
        <Button size="sm" variant="secondary" onClick={() => send('open_cover')}>
          Open
        </Button>
        <Button size="sm" variant="secondary" onClick={() => send('stop_cover')}>
          Stop
        </Button>
        <Button size="sm" variant="secondary" onClick={() => send('close_cover')}>
          Close
        </Button>
      </div>
    </div>
  );
}
